<template>
    <Link :href="$$route(routing, { id: askForQuoteId })" class="btn" :class="{'active' : activeClass}"><slot></slot> <span class="state" :class="stateColor"></span></Link>
</template>

<script>

export default {
    name: 'MenuTabsItem',
    props: [
        'routing',
        'askForQuoteId',
        'state',
        'stateHalf',
    ],
    computed: {
        stateColor() {
            return this.state === true ? 'state--green' : this.stateHalf === true ? 'state--half' : 'state--red';
        },
        fullRoute() {
            return this.getRoute('.' + this.routing);
        },
        activeClass() {
            return this.$route().current() === this.fullRoute ? 'active' : '';
        }
    }
};
</script>
